@if (selectMode) {
  <div class="d-flex gap-2">
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-toggles"></i></span>
      <select class="form-select" [(ngModel)]="mode" [ngModelOptions]="{standalone: true}" (ngModelChange)="onModeChanged()">
        <option value="none">None</option>
        <option value="product">Single product</option>
        @if (priorityList) {
          <option value="list">Priority list</option>
        }
      </select>
    </div>
    @if (isModeProduct()) {
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-box"></i></span>
        <select class="form-select" [(ngModel)]="value" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChanged()">
          @for (product of getProducts(); track product) {
            <option [ngValue]="product.identifier">{{ product.name }}</option>
          }
        </select>
      </div>
    }
    @if (isModeList()) {
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-box"></i></span>
        <select class="form-select" [(ngModel)]="value" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChanged()">
          @for (productPriority of getProductPriorities(); track productPriority) {
            <option
              [ngValue]="productPriority.identifier">{{ productPriority.name }}
            </option>
          }
        </select>
      </div>
    }
  </div>
} @else {
  <div class="d-flex justify-content-between">
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" [name]="componentId+'-mode'" [id]="componentId+'-none'" value="none"
        [(ngModel)]="mode" [ngModelOptions]="{standalone: true}" (click)="value=null" (ngModelChange)="onChanged()">
      <label class="form-check-label" [for]="componentId+'-none'">None</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" [name]="componentId+'-mode'" [id]="componentId+'-product'"
        value="product" [(ngModel)]="mode" [ngModelOptions]="{standalone: true}">
      <label class="form-check-label" [for]="componentId+'-product'">Single product</label>
    </div>
    @if (priorityList) {
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" [name]="componentId+'-mode'" [id]="componentId+'-list'" value="list"
          [(ngModel)]="mode" [ngModelOptions]="{standalone: true}">
        <label class="form-check-label" [for]="componentId+'-list'">Priority list</label>
      </div>
    }
    <div class="w-50">
      @if (isModeProduct()) {
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-box"></i></span>
          <select class="form-select" [(ngModel)]="value" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChanged()">
            @for (product of getProducts(); track product) {
              <option [ngValue]="product.identifier">{{ product.name }}</option>
            }
          </select>
        </div>
      }
      @if (isModeList()) {
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-box"></i></span>
          <select class="form-select" [(ngModel)]="value" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChanged()">
            @for (productPriority of getProductPriorities(); track productPriority) {
              <option
                [ngValue]="productPriority.identifier">{{ productPriority.name }}
              </option>
            }
          </select>
        </div>
      }
    </div>
  </div>
}
